/**
 * chatDemos.ts — All chat demo scenarios for ChatDemoTile component
 *
 * v1.0 - Migrated from heroExamples in Landing.tsx - 2026-03-23
 *
 * To add a new demo scenario: add a new object to the chatDemos array.
 * No changes to ChatDemoTile.tsx are required.
 */

export interface ChatDemo {
  id: string;
  question: string;
  metric: string;
  metricLabel: string;
  recommendation: string;
}

export const chatDemos: ChatDemo[] = [
  {
    id: 'dispatch',
    question: 'Where is your team losing billable time?',
    metric: '31%',
    metricLabel: 'of paid hours last week were drive time',
    recommendation: 'Rerouting overlapping dispatches saves ~$2,600/month',
  },
  {
    id: 'sku-inventory',
    question: 'Which inventory is costing you money right now?',
    metric: '$34K',
    metricLabel: 'tied up in SKUs that have not moved in 90+ days',
    recommendation: 'Clearing slow-moving stock frees $34,000 in working capital',
  },
  {
    id: 'repeat-clients',
    question: 'Am I making money on my repeat clients?',
    metric: '22%',
    metricLabel: 'average labor overrun across last 4 jobs with top client',
    recommendation: 'Fixing the quote underestimate recovers ~$1,800 per job',
  },
  {
    id: 'staffing',
    question: 'Where is my staffing misaligned with revenue?',
    metric: '40%',
    metricLabel: 'more staff on your lowest-revenue day vs your busiest',
    recommendation: 'Rebalancing saves approximately $620/week in excess labor cost',
  },
  {
    id: 'sku-margin',
    question: 'Am I still making money on my top products?',
    metric: '3%',
    metricLabel: 'loss on your top SKU after supplier price increase',
    recommendation: 'Adjusting retail pricing recovers ~$1,100/month in margin',
  },
];
